<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new"
            :back-button="true"
            :bigTotal="bigTotal"
            :loading="loading"
            :total="total"
            :label="'Lead'">
      <a @click="loadItems()" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-sync"></i></span>
        <span>Actualiser données</span>
      </a>
    </sticky>
    <div class="columns collapseColumn collapseColumn--left collapseColumn--alignStart" id="columns-collapse"
         :class="opened ? 'is-active-collapse' : 'is-inactive-collapse'">
      <div class="column is-4 is-3-widescreen is-3-fullhd">
        <list-filter @resetFilters="resetFilters"
                     @changeFilters="changeFilters"
                     :total="total"
                     :bigTotal="bigTotal"
                     :loading="loading"
                     :hasFilter="hasFilter"
                     @opened="opened = !opened">
          <div class="columns">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <label class="label">Lead convertis</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="filters.exported" @input="inputChange">
                    <option :value="null">Tous</option>
                    <option :value="0">Non</option>
                    <option :value="1">Oui</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
         <div class="columns">
           <div class="column is-padding-top-small">
             <div class="control">
               <multiselect v-model="filters.origin" track-by="pk"
                            @input="val => updateKeyFilter(val, 'origin')"
                            class="multiselect&#45;&#45;option-ico"
                            :custom-label="val => limitText(val.name)"
                            :value="filters.origin_name" :close-on-select="false"
                            group-values="children" group-label="name" :group-select="true" :multiple="true"
                            :options="originGroups" :searchable="true" :show-labels="false"
                            @search-change="getOrigins" :placeholder="''">
                 <template slot="clear" slot-scope="props">
                   <div class="multiselect__clear" v-if="origins.length"
                        @mousedown.prevent.stop="clearAll(props.search)"></div>
                 </template>
                 <span slot="noResult">Oups! Aucune origine trouvée.</span>
                 <span slot="placeholder" class="multiselect__placeholder">Origine(s)</span>
                 <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                   <span>Origine(s) ({{values.length}})</span>
                 </span>
                 <span slot="noOptions">La liste est vide</span>
               </multiselect>
             </div>
           </div>
         </div>
          <div class="columns">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <label class="label">Lead attribués</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="filters.assigned" @input="inputChange">
                    <option :value="null">Tous</option>
                    <option :value="0">Non</option>
                    <option :value="1">Oui</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns" v-if="isAdmin || isOperator">
            <div class="column is-paddingless-bottom is-padding-top-xsmall">
              <div class="control">
                <multiselect @select="updateSellerFilter" @remove="updateSellerFilter(null)"
                             v-model="filters.seller" label="name" track-by="pk"
                             class="multiselect--option-ico"
                             :options="sellers" :searchable="true" :show-labels="false"
                             @search-change="getSellers" :placeholder="''"
                             :custom-label="personName">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="sellers.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucun vendeur trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                    <span>Vendeurs(s) ({{values.length}})</span>
                  </span>
                  <span slot="placeholder" class="multiselect__placeholder">Vendeur</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns is-margin-bottom">
            <div class="column is-paddingless-bottom is-padding-top-xsmall">
              <div class="control">
                <multiselect @select="updateProgramFilter" @remove="updateProgramFilter(null)"
                             class="multiselect--option-ico"
                             v-model="filters.program" label="name" track-by="pk"
                             :options="programs" :searchable="true" :show-labels="false"
                             :placeholder="''" @search-change="getPrograms">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="programs.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucun programme trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                    <span>Programme(s) ({{values.length}})</span>
                  </span>
                  <span slot="placeholder" class="multiselect__placeholder">Programme</span>
                </multiselect>
              </div>
            </div>
          </div>
        </list-filter>
      </div>
      <div class="column is-8 is-9-widescreen is-9-fullhd is-paddingless-bottom is-paddingless-left">
        <div class="is-border">
          <div class="columns is-gapless row-width-actions-bar is-border-bottom">
            <transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster"
                        mode="out-in">
              <div class="column is-narrow has-bg-primary columns is-vcentered is-gapless"
                   v-if="hasFilter && !loading && total !== bigTotal">
                <div class="column is-padding-left is-padding-right has-text-white">Résultat : {{total || 0}} lead(s)
                </div>
              </div>
            </transition>
            <div class="column"></div>
            <div class="column is-paddingless is-border-left is-narrow" slot="right-content">
              <a class="page-header-btn tooltip is-square is-tooltip-bottom is-tooltip-primary"
                 :data-tooltip="fullscreen ? 'Réduire' : 'Agrandir'" @click="toggleFullscreen">
                <span class="icon">
                  <i class="fal" :class="fullscreen ? 'fa-compress-wide' : 'fa-expand-wide'"></i>
                </span>
              </a>
            </div>
          </div>
          <div class="is-padding" v-if="(hasFilter || filters.exported !== null) && !loading">
            <label for="" class="is-size-6 label is-padding-bottom-small">Vos critères de recherche :</label>
            <div class="tags">
              <span class="tag is-primary is-rounded" v-if="filters.exported !== null">
                <span v-if="filters.exported === '0' || filters.exported === 0">Lead non convertis</span>
                <span v-else>Lead convertis</span> <a @click="removeExport()" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
               <span class="tag is-primary is-rounded" v-if="filters.assigned !== null">
                  <span v-if="filters.assigned === '0' || filters.assigned === 0">Lead non attribué</span>
                  <span v-else>Lead attribué</span> <a @click="removeAssignedFilter()" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.origin"
                    v-for="(origin, i) in filters.origin" :key="'origin-' + i">
                {{origin.name}} <a @click="deleteFilter(i, 'origin')" class="icon is-white is-margin-left-xsmall"><i
                class="fas fa-times-circle has-text-white"></i></a>
              </span>
               <span class="tag is-primary is-rounded" v-if="filters.seller && filters.seller && (isAdmin || isOperator)">
                {{personName(filters.seller)}} <a @click="updateSellerFilter(null)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.program">
                {{filters.program.name}} <a @click="updateProgramFilter(null)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-annonce is-rounded has-cursor-pointer" @click="resetFilters">
                Réinitialiser les filtres <span class="icon is-white is-margin-left-xsmall"><i class="fas fa-undo"></i></span>
              </span>
            </div>
          </div>
          <table-h-scroll :has-sticky="true" :sticky-styles="stickyStyles"
                          :sticky-datas="stickyDatas" :reload-controls="loading && items.length">
            <table v-show="!loading && items.length"
                   class="table is-fullwidth is-narrow is-striped-v is-first-fixed-small is-last-fixed-small is-marginless-bottom has-actionsontd">
              <thead>
              <tr class="is-size-6">
                <th class="is-paddingless has-text-centered actions" style="z-index:2;">
                  <div class="dropdown is-hoverable is-left">
                    <div class="dropdown-trigger">
                      <button class="button is-circle is-small" aria-haspopup="true" aria-controls="dropdown-menu">
                        <i class="fal fa-cog"></i>
                      </button>
                    </div>
                    <columns-toggles :entries="columnsList" :source="columns" @update="updateColumns"></columns-toggles>
                  </div>
                </th>
                <th>
                  <sortable @sort="sort('created_on', $event)" :sort="sortBy.created_on" label="Date"></sortable>
                </th>
                <th>
                  <sortable @sort="sort('origin_name', $event)" :sort="sortBy.origin_name" label="Origine"></sortable>
                </th>
                <th>
                  <sortable @sort="sort('last_name', $event)" :sort="sortBy.last_name" label="Nom"></sortable>
                </th>
                <th>
                  <sortable @sort="sort('first_name', $event)" :sort="sortBy.first_name" label="Prénom"></sortable>
                </th>
                <th v-if="showColumn('email')">
                  <sortable @sort="sort('email', $event)" :sort="sortBy.email" label="Email"></sortable>
                </th>
                <th v-if="showColumn('phone')">
                  Téléphone
                </th>
                <th v-if="showColumn('program')">
                  <sortable @sort="sort('program', $event)" :sort="sortBy.program" label="Programme"></sortable>
                </th>
                <th>
                  <sortable @sort="sort('assigned', $event)" :sort="sortBy.assigned" label="Atrribué"></sortable>
                </th>
                <th>
                  <sortable @sort="sort('seller_name', $event)" :sort="sortBy.seller_name" label="Référent"></sortable>
                </th>
                <th class="has-text-centered" width="70px">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(lead, i) in items" :key="lead.pk" class="is-size-6" :id="'e' + lead.pk"
                  :class="{'has-status-bar--left has-status-bar--draft':scrollToEl === lead.pk}">
                <td class="is-paddingless has-text-centered actions">
                  <avatar :item="lead" :i="i"></avatar>
                </td>
                <td>
                  {{lead.created_on | prettyDatetime}}
                </td>
                <td>
                  {{lead.origin_name}}
                </td>
                <router-link
                  :to="{name: 'LeadVue', params: {id: lead.pk}, query: {returnId: lead.pk, page: currentPage}}" tag="td"
                  class="is-cell-hoverable is-narrow">
                  <a class="fullLink">{{lead.last_name}}</a>
                </router-link>
                <router-link
                  :to="{name: 'LeadVue', params: {id: lead.pk}, query: {returnId: lead.pk, page: currentPage}}" tag="td"
                  class="is-cell-hoverable is-narrow">
                  <a class="fullLink">{{lead.first_name}}</a>
                </router-link>
                <td :class="{'is-cell-hoverable': lead.email}" v-if="showColumn('email')">
                  <span v-if="lead.email">{{lead.email}}</span>
                  <span v-else>N.C</span>
                </td>
                <td :class="{'is-cell-hoverable': lead.phone}" v-if="showColumn('phone')">
                  <span v-if="lead.phone">{{lead.phone}}</span>
                  <span v-else>N.C</span>
                </td>
                <td :class="{'is-cell-hoverable': lead.program}" v-if="showColumn('program')">
                  <span v-if="lead.program">{{lead.program_name}}</span>
                  <span v-else>N.C</span>
                </td>
                <td><span v-if="lead.assigned">Oui</span><span v-else>Non</span></td>
                <td :class="{'is-cell-hoverable': lead.seller}">
                  <span v-if="lead.seller">{{lead.seller_name}}</span>
                  <span v-else>N.C</span>
                </td>
                <td class="has-text-centered actions">
                  <display-button-list :buttons="buttonList" :data="lead"></display-button-list>
                </td>
              </tr>
              </tbody>
            </table>
          </table-h-scroll>
          <div class="is-border-top" v-if="totalPage > 1 && nextPage && !loading">
            <a class="button is-light is-fullwidth has-text-grey" @click="loadMore(true)" v-if="!infiniteLoading">
              <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
              <span class="is-size-6">Afficher la suite</span>
            </a>
            <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px">
            </div>
          </div>
          <div v-show="!loading && !items.length">
            <div class="columns">
              <div class="column">
                <h2 class="title is-3 has-text-weight-bold">Aucun Lead disponible</h2>
                <a class="has-text-primary" @click="resetFilters" v-if="hasFilter"><span class="icon is-small"><i
                  class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {GenericList, Sort, Filter, ColumnConf, TableHeaderSticky} from '../../mixins'
  import {isPlainObject} from 'lodash'
  import {mapGetters, mapState} from 'vuex'

  export default {
    name: 'LeadList',
    mixins: [GenericList, Sort, Filter, ColumnConf, TableHeaderSticky],
    data () {
      return {
        columnsConfResource: 'lead',
        loadDocuments: this.loadItems,
        origins: [],
        originsFilter: [],
        sellers: [],
        programs: [],
        service: this.$api.leadService,
        fullscreen: false,
        buttonList: [
          {
            action: (id) => {
              let actionId = id
              this.$router.push({
                name: 'LeadVue',
                params: {id: actionId},
                query: {returnId: actionId, page: this.currentPage}
              })
            },
            icon: 'fa-eye',
            text: 'Voir'
          }
        ],
        filters: {
          exported: 0,
          assigned: null,
          seller: null,
          program: null
        },
        initFilters: {
          exported: null,
          assigned: null
        },
        infiniteLoaderEnabled: true
      }
    },
    computed: {
      ...mapState({
        scrollToEl: 'scrollToEl',
        originsList: 'origins'
      }),
      ...mapGetters(['isAdmin', 'isOperator', 'currentUserPk', 'originGroups']),
      columnsShow () {
        return {
          'email': {label: 'Email', mobile: false},
          'phone': {label: 'Téléphone', mobile: false},
          'program': {label: 'Programme', mobile: false}
        }
      }
    },
    methods: {
      updateProgramFilter (e) {
        this.$set(this.filters, 'program', e ? e.pk : null)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      personName (value) {
        if (value && value.last_name && value.first_name) {
          return `${value.last_name} ${value.first_name}`
        }
      },
      updateSellerFilter (e) {
        this.$set(this.filters, 'seller', e ? e.pk : null)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      removeExport () {
        this.filters.exported = null
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      removeAssignedFilter () {
        this.filters.assigned = null
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      limitText (text) {
        if (text.length > 20) {
          return text.substring(0, 15) + '...'
        } else return text
      },
      updateKeyFilter (e, key) {
        this.$set(this.filters, key, e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      getOrigins (name) {
        this.$api.originService.get({name, sort: 'name:asc'}).then(r => {
          this.origins = r.data
        })
      },
      getSellers (query) {
        this.$api.userService.get({
          last_name: query,
          profil_type: ['manager', 'seller', 'admin', 'operator'],
          sort: 'last_name:asc'
        }).then(r => {
          this.sellers = r.data.items
        })
      },
      getPrograms (name) {
        this.$api.programService.get({
          name,
          sort: 'name:asc'
        }).then(r => {
          this.programs = r.data.items
        })
      },
      beforeGet () {
        if (this.query.program && isPlainObject(this.query.program)) {
          this.query.program = this.query.program.pk
        }
        if (Array.isArray(this.query.program)) {
          this.query.program = this.query.program.map(x => x.pk)
        }
        if (this.query.seller && isPlainObject(this.query.seller)) {
          this.query.seller = this.query.seller.pk
        }
        if (Array.isArray(this.query.origin)) {
          this.query.origin = this.query.origin.map(x => x.pk)
        }
        if (this.query.origin && isPlainObject(this.query.origin)) {
          this.query.origin = this.query.origin.pk
        }
        if (Array.isArray(this.query.seller)) {
          this.query.seller = this.query.seller.map(x => x.pk)
        }
        this.query.from = 'list'
      },
      originName (origin) {
        if (origin.parent_name) {
          return origin.parent_name + ' - ' + origin.name
        } else {
          return origin.name
        }
      },
      toggleFullscreen () {
        this.fullscreen = !this.fullscreen
        if (this.fullscreen) {
          document.querySelector('body').classList.add('has-contentmain-fullscreen')
          document.querySelector('body').classList.remove('has-contentmain-fullscreen-leave')
          document.querySelector('.l-header').style.zIndex = '0'
          document.querySelector('.l-navigationmain').style.zIndex = '0'
        } else {
          document.querySelector('body').classList.add('has-contentmain-fullscreen-leave')
          document.querySelector('body').classList.remove('has-contentmain-fullscreen')
          document.querySelector('.l-header').style.zIndex = '36'
          document.querySelector('.l-navigationmain').style.zIndex = '37'
        }
      },
      deleteFilter (i, key) {
        this.filters[key].splice(i, 1)
        this.$nextTick(() => {
          this.changeFilters()
        })
      }
    },
    created () {
      if (!this.isAdmin && !this.isOperator) {
        this.filters.seller = this.currentUserPk
        this.initFilters.seller = this.currentUserPk
      }
      if (!('exported' in this.$route.query) && this.$route.query.from === 'list') {
        this.filters.exported = null
        this.query.exported = null
      }
      delete this.filters.from
      delete this.query.from
      this.$nextTick(() => {
        this.changeFilters()
        this.origins = this.originsList.slice()
        this.getSellers()
        this.getPrograms()
      })
    }
  }
</script>

<style>
  is-annonce {
    background-color: #f87051
  }
</style>



// WEBPACK FOOTER //
// src/components/lead/LeadList.vue